import React, { useState } from 'react';
import styled from 'styled-components';
import { CpPopover } from '../modal/cp-popover';
import { CpApprovalsAndCsatContent } from './cp-approvals-and-csat-content';

const StyledPopover = styled(CpPopover)``;

export const CpApprovalsAndCsat: React.FC = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <StyledPopover
      placement="bottomLeft"
      content={<CpApprovalsAndCsatContent onVisiblityChange={setIsVisible} />}
      getPopupContainer={() =>
        document.getElementById('cp-modal-root') as HTMLElement
      }
      visible={isVisible}
      onVisibleChange={setIsVisible}
      getTooltipContainer={() =>
        document.getElementById('cp-modal-root') as HTMLElement
      }
    >
      <span>{children}</span>
    </StyledPopover>
  );
};
